import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getGalleryInner } from "../Service/Api";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import Breadcrumb from "../Component/Breadcrumb";
import LazyLoad from "react-lazyload";

const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const Gallery = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [filterData, setFilteredData] = useState([]);
  const [selectedYear, setSelectedYear] = useState("2025");
  const [selectedMonth, setSelectedMonth] = useState("All");
  const [monthOptions, setMonthOptions] = useState(["All"]);
  const [yearRanges, setYearRanges] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const convertDateToDDMMYYYY = (isoString) => {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        if (!selectedYear) return;

        console.log("🔄 Fetching data for year:", selectedYear);
        const response = await getGalleryInner("AFGJI", selectedYear); // pass schoolCode & year

        const formatted = response.map((item) => ({
          ...item,
          formattedDate: item.date ? convertDateToDDMMYYYY(item.date) : null,
        }));
        setData(formatted);

        const months = new Set();
        formatted.forEach((item) => {
          if (item.date) months.add(new Date(item.date).getMonth());
        });
        const sortedMonths = Array.from(months)
          .sort((a, b) => a - b)
          .map((i) => monthNames[i]);
        setMonthOptions(["All", ...sortedMonths]);
      } catch (err) {
        console.error("❌ Error fetching gallery:", err);
      }
    };

    fetchGallery();
  }, [selectedYear]);

  useEffect(() => {
    let filtered = data;

    if (selectedMonth !== "All") {
      filtered = filtered.filter((item) => {
        if (!item.date) return false;
        const month = monthNames[new Date(item.date).getMonth()];
        return selectedMonth === month;
      });
    }

    if (searchQuery.trim()) {
      filtered = filtered.filter((item) =>
        item.title.toLowerCase().includes(searchQuery.toLowerCase()),
      );
    }

    filtered.sort((a, b) => new Date(b.date) - new Date(a.date));
    setFilteredData(filtered);
  }, [data, selectedMonth, searchQuery]);

  const emptyArray = [
    {
      description: "Stay tuned for the latest updates.",
      attachments: ["director.jpg"],
    },
  ];

  return (
    <>
      <Header />
      <Breadcrumb pageTitle="Photo Gallery" breadcrumbName="Photo Gallery" />
      <div className="body_height">
        <div className="container">
          <div className="row tabs-dynamic">
            <div className="col-lg-3">
              <p>Total Items: {filterData.length}</p>
            </div>
            <div className="col-lg-3">
              <select
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
                className="yearSelection"
              >
                <option value="All">All</option>
                <option value="2025">2025</option>
                <option value="2024">2024</option>
                <option value="2023">2023</option>
                <option value="2022">2022</option>
                <option value="2021">2021</option>
                <option value="2020">2020</option>
                <option value="2019">2019</option>
                <option value="2018">2018</option>
                <option value="2017">2017</option>
                <option value="2016">2016</option>
                <option value="2015">2015</option>
              </select>
            </div>
            <div className="col-lg-3">
              <select
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
                className="monthSelect"
              >
                {monthOptions.map((month, idx) => (
                  <option key={idx} value={month}>
                    {month}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-lg-3">
              <input
                type="text"
                placeholder="Search Here..."
                className="form-control"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>

          <div className="row mt-3">
            {filterData.length > 0
              ? filterData.map((item, index) => (
                  <div
                    className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12 galleryCount"
                    key={index}
                  >
                    <div className="gal_new">
                      <article>
                        <LazyLoad>
                          <img
                            src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item?.attachments?.[0]}`}
                            alt={item.title}
                            className="img-fluid"
                            onError={(e) => {
                              e.target.src = "/default-image.jpg";
                            }}
                          />
                        </LazyLoad>
                        <div className="gal-content">
                          <h4 className="catgry-name">{item.title}</h4>
                          <p>{item.description}</p>
                          <h6 className="date">
                            <i className="bi bi-calendar-week"></i>{" "}
                            {item.formattedDate}
                            <span>
                              <a
                                onClick={() =>
                                  navigate(`/SubGallery?id=${item._id}`)
                                }
                              >
                                <i className="bi bi-arrow-right"></i>
                              </a>
                            </span>
                          </h6>
                          <div className="total-img">
                            <i className="bi bi-card-image"></i>
                            <p>{item?.attachments?.length}</p>
                          </div>
                        </div>
                      </article>
                    </div>
                  </div>
                ))
              : emptyArray.map((entry, index) => (
                  <div
                    key={index}
                    className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12 galleryCount"
                  >
                    <div className="gal_new">
                      <article>
                        <LazyLoad>
                          <img
                            src="/default-image.jpg"
                            alt="No Image"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <div className="gal-content">
                          <h4 className="catgry-name">Gallery Title</h4>
                          <p>{entry.description}</p>
                          <h6 className="date">
                            <i className="bi bi-calendar-week"></i> DD MM YYYY
                          </h6>
                          <div className="total-img">
                            <i className="bi bi-card-image"></i>
                            <p>0</p>
                          </div>
                        </div>
                      </article>
                    </div>
                  </div>
                ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Gallery;
